import { motion, AnimatePresence } from 'framer-motion';
import { forwardRef } from 'react';
import { FiSearch, FiArrowLeft, FiX, FiTrash2 } from 'react-icons/fi';


const MessagesPanel = forwardRef(function MessagesPanel({
  isOpen,
  chats, selectedChat, messages, text, setText,
  chatError, searchQuery, searchResults, chatBoxRef,
  onSend, onSearch, onSelectChat, onStartChat, onDeleteChat, onClose,
}, ref) {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          key="messages-panel"
          className="panel messages-panel"
          ref={ref}
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.2 }}
        >
          (
            <>
              {/* Header */}
              <div className="panel-header">
                <h3 className="panel-title" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  {selectedChat ? (
                    <>
                      <button className="panel-back-btn" onClick={() => onSelectChat(null)}>
                        <FiArrowLeft size={16} />
                      </button>
                      @{selectedChat.otherUsername}
                    </>
                  ) : 'Mesajlar'}
                </h3>
                <button className="panel-close-btn" onClick={onClose}><FiX size={16} /></button>
              </div>

              {/* Content */}
              <div className="panel-body">
                {!selectedChat && (
                  <div className="panel-search">
                    <FiSearch size={14} style={{ color: 'var(--text-muted)' }} />
                    <input
                      type="text"
                      value={searchQuery}
                      onChange={(e) => onSearch(e.target.value)}
                      placeholder="Kullanıcı ara..."
                      className="input"
                      style={{ border: 'none', background: 'transparent', padding: '4px' }}
                    />
                  </div>
                )}

                {!selectedChat && searchResults.length > 0 && (
                  <div className="panel-search-results">
                    {searchResults.map((user) => (
                      <div key={user.id} className="panel-item" onClick={() => onStartChat(user)}>
                        <div className="panel-avatar">
                          {user.profilePhoto ? (
                            <img src={user.profilePhoto} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} />
                          ) : '👤'}
                        </div>
                        <span>@{user.username}</span>
                      </div>
                    ))}
                  </div>
                )}

                {selectedChat ? (
                  <div className="chat-container">
                    <div className="chat-box" ref={chatBoxRef}>
                      {messages.map((msg) => (
                        <div key={msg.id} className={`chat-msg ${msg.from === localStorage.getItem('userId') ? 'chat-msg--mine' : 'chat-msg--other'}`}>
                          <span className="chat-msg-text">{msg.text}</span>
                          <span className="chat-msg-time">
                            {msg.timestamp?.toDate?.()?.toLocaleTimeString?.([], { hour: '2-digit', minute: '2-digit' }) || ''}
                          </span>
                        </div>
                      ))}
                    </div>
                    <div className="chat-input-row">
                      <input
                        type="text" value={text} onChange={(e) => setText(e.target.value)}
                        placeholder="Mesaj yaz..." className="input"
                        onKeyDown={(e) => e.key === 'Enter' && onSend()}
                        style={{ flex: 1 }}
                      />
                      <button className="btn btn-primary btn-sm" onClick={onSend}>Gönder</button>
                    </div>
                    {chatError && <p className="text-danger text-xs" style={{ marginTop: '8px' }}>{chatError}</p>}
                  </div>
                ) : chats.length === 0 && searchResults.length === 0 ? (
                  <p className="panel-empty">Henüz bir sohbetiniz yok.</p>
                ) : (
                  chats.map((chat) => (
                    <div key={chat.id} className="panel-item panel-chat-item">
                      <div className="panel-item-content" onClick={() => onSelectChat(chat)} style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
                        <div className="panel-avatar">
                          {chat.otherPhoto ? (
                            <img src={chat.otherPhoto} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} />
                          ) : '👤'}
                        </div>
                        <div>
                          <div style={{ color: 'var(--accent-primary)', fontSize: 'var(--text-sm)' }}>@{chat.otherUsername}</div>
                          <div className="text-muted text-xs">{chat.lastMessage || 'Mesaj yok'}</div>
                        </div>
                        <span className="text-muted text-xs" style={{ marginLeft: 'auto' }}>{chat.timestamp}</span>
                      </div>
                      <button className="panel-delete-btn" onClick={(e) => { e.stopPropagation(); onDeleteChat(chat.id); }}>
                        <FiTrash2 size={14} />
                      </button>
                    </div>
                  ))
                )}
              </div>
            </>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
});

export default MessagesPanel;
